export const environment = {
  production: false,
  demo: false,
  name: 'nautopsy-demo',
  apiUrl: 'https://demobackend.nautopsy.hu',
  eszigReaderUrl: '',
  logoUrl: 'images/nautopsy_logo_04-02-05.png',
  navbarLogoUrl: 'images/nautopsy_navbar_logo.png'
};
